// hooks/useDiscountedProducts.js
import { useState, useEffect } from 'react';
import { BASE_URL } from '../config';
export const useDiscountedProducts = () => {
    const [discountedProducts, setDiscountedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDiscountedProducts = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${BASE_URL}api/v1/products/discounted`);

                if (!response.ok) {
                    throw new Error(`Failed to fetch discounted products: ${response.status} ${response.statusText}`);
                }

                const data = await response.json();

                // Handle response format
                const products = data.data || data;

                if (!Array.isArray(products)) {
                    throw new Error('Invalid response format: expected array of products');
                }

                setDiscountedProducts(products);

            } catch (err) {
                setError(err.message);
                console.error('Error fetching discounted products:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchDiscountedProducts();
    }, []);

    return { discountedProducts, loading, error };
};